var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPoints = function SvgIconPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.643 18.174a.376.376 0 0 1 .714 0l.672 2.017a3.01 3.01 0 0 0 1.905 1.904l2.017.672c.343.114.343.6 0 .714l-2.018.672a3.01 3.01 0 0 0-1.904 1.905l-.672 2.017a.377.377 0 0 1-.714 0l-.672-2.018a3.01 3.01 0 0 0-1.904-1.904l-2.017-.672a.376.376 0 0 1 0-.714l2.017-.672a3.01 3.01 0 0 0 1.904-1.904zm-4.024-5.311a.226.226 0 0 1 .43 0l.402 1.21c.18.54.604.963 1.143 1.143l1.21.403a.226.226 0 0 1 0 .429l-1.21.403a1.8 1.8 0 0 0-1.143 1.142l-.403 1.21a.226.226 0 0 1-.429 0l-.403-1.21a1.8 1.8 0 0 0-1.142-1.142l-1.21-.403a.226.226 0 0 1 0-.43l1.21-.402a1.8 1.8 0 0 0 1.142-1.143zm7.363-1.093a.151.151 0 0 1 .285 0l.269.806c.12.36.402.643.762.763l.807.268a.151.151 0 0 1 0 .286l-.807.269a1.2 1.2 0 0 0-.762.762l-.269.806a.15.15 0 0 1-.285 0l-.269-.806a1.2 1.2 0 0 0-.762-.762l-.805-.27a.15.15 0 0 1 0-.284l.806-.27c.36-.119.642-.401.762-.762l.268-.805"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 19.5
  })));
};
export default SvgIconPoints;